var map = {
	"./dart-off-left.svg": 66646,
	"./dart-off-right.svg": 18869,
	"./dart-target.svg": 60238,
	"./gameOptions1.svg": 12914,
	"./gameOptions2.svg": 17953,
	"./gameOptions3.svg": 5712,
	"./gameOptions4.svg": 71599,
	"./gameOptions5.svg": 9022,
	"./gameOptions6.svg": 63197,
	"./global-home.svg": 35638,
	"./happy-play.svg": 49418,
	"./how-to-earn.svg": 58378,
	"./how-to-fund.svg": 73689,
	"./how-to-play.svg": 8034,
	"./legacy-selectors/1/1.svg": 31579,
	"./legacy-selectors/1/2.svg": 80840,
	"./legacy-selectors/1/3.svg": 46233,
	"./legacy-selectors/1/4.svg": 89846,
	"./legacy-selectors/1/5.svg": 70023,
	"./legacy-selectors/1/6.svg": 5460,
	"./legacy-selectors/1/7.svg": 78069,
	"./legacy-selectors/1/8.svg": 23954,
	"./legacy-selectors/1/9.svg": 38595,
	"./legacy-selectors/2/1.svg": 43100,
	"./legacy-selectors/2/2.svg": 22127,
	"./legacy-selectors/2/3.svg": 59550,
	"./legacy-selectors/2/4.svg": 84833,
	"./legacy-selectors/2/5.svg": 72592,
	"./legacy-selectors/2/6.svg": 17731,
	"./legacy-selectors/2/7.svg": 79794,
	"./legacy-selectors/2/8.svg": 3285,
	"./legacy-selectors/2/9.svg": 61300,
	"./legacy-selectors/3/1.svg": 81157,
	"./legacy-selectors/3/2.svg": 61286,
	"./legacy-selectors/3/3.svg": 7735,
	"./legacy-selectors/3/4.svg": 12664,
	"./legacy-selectors/3/5.svg": 88169,
	"./legacy-selectors/3/6.svg": 62586,
	"./legacy-selectors/3/7.svg": 67851,
	"./legacy-selectors/3/8.svg": 36524,
	"./legacy-selectors/3/9.svg": 88333,
	"./legacy-selectors/4/1.svg": 47702,
	"./legacy-selectors/4/2.svg": 60661,
	"./legacy-selectors/4/3.svg": 15732,
	"./legacy-selectors/4/4.svg": 47355,
	"./legacy-selectors/4/5.svg": 5386,
	"./legacy-selectors/4/6.svg": 31385,
	"./legacy-selectors/4/7.svg": 65992,
	"./legacy-selectors/4/8.svg": 24143,
	"./legacy-selectors/4/9.svg": 61566,
	"./legacy-selectors/5/1.svg": 37199,
	"./legacy-selectors/5/2.svg": 34876,
	"./legacy-selectors/5/3.svg": 63421,
	"./legacy-selectors/5/4.svg": 29490,
	"./legacy-selectors/5/5.svg": 32803,
	"./legacy-selectors/5/6.svg": 27056,
	"./legacy-selectors/5/7.svg": 18177,
	"./legacy-selectors/5/8.svg": 60758,
	"./legacy-selectors/5/9.svg": 23975,
	"./legacy-selectors/6/1.svg": 80304,
	"./legacy-selectors/6/2.svg": 37347,
	"./legacy-selectors/6/3.svg": 22706,
	"./legacy-selectors/6/4.svg": 56637,
	"./legacy-selectors/6/5.svg": 67164,
	"./legacy-selectors/6/6.svg": 46191,
	"./legacy-selectors/6/7.svg": 2462,
	"./legacy-selectors/6/8.svg": 44985,
	"./legacy-selectors/6/9.svg": 79592,
	"./lostIcon.svg": 2390,
	"./modal-next.svg": 12772,
	"./nav-settings-large.svg": 13198,
	"./nav-settings.svg": 79776,
	"./thumbs-up.svg": 62974,
	"./watch-demo.svg": 4356,
	"./wonIcon.svg": 11050
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 36869;